export const PageDataState = {
    Searchs: {
        eec_nets_id: {
            type: 'text',
            id: 'eec_nets_id',
            label: '',
            value: '',
        },
        network_performance_types: {
            type: 'select',
            id: 'network_performance_types',
            label: 'ประเภท',
            value: '',
        },
        courses: {
            type: 'text',
            id: 'courses',
            label: 'หลักสูตร',
            value: '',
            placeholder: 'หลักสูตร',
        },
        network_performance_name: {
            type: 'text',
            id: 'network_performance_name',
            label: 'หัวข้อ',
            value: '',
            placeholder: 'การขับเคลื่อนการศึกษาฯ',
        },
        network_performance_status: {
            type: 'select',
            id: 'network_performance_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        eec_nets_id: {
            type: 'select',
            id: 'eec_nets_id',
            label: 'ศูนย์เครือข่าย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        types: {
            type: 'select',
            id: 'types',
            label: 'ประเภท',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },  
        courses: {
            type: 'textarea',
            rows: 3,
            id: 'courses',
            label: 'หลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        numberOfTrainees: {
            type: 'text',
            id: 'numberOfTrainees',
            label: 'จำนวน',
            value: '',
            validator: {
                type: 'number',
                required: false,
                minLength: 1,
                maxLength: 1000
            },
            error: { status: null, msg: '' }
        },     
        years: {
            type: 'select',
            id: 'years',
            label: 'ปี',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },  
        name: {
            type: 'text',
            id: 'name',
            label: 'หัวข้อ',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        description: {
            type: 'textarea',
            rows: '3',
            id: 'description',
            label: 'รายละเอียด',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }       
    },
    InputGroup: {}
}